import CircularProgress from "@mui/material/CircularProgress";
import "./host-activity.css";

// A `p-progressSpinner`: 100PX, STROKE 2 BY DEFAULT, ITS STROKE CYCLING THROUGH PRIMENG'S FOUR
// COLORS. PRIMENG'S `strokeWidth` IS IN A 50-UNIT VIEWBOX AND MUI'S `thickness` IN A 44-UNIT
// ONE, HENCE THE SCALE.
export function ProgressSpinner({ size = 100, strokeWidth = 2 }: { size?: number; strokeWidth?: number }) {
  return <CircularProgress color="inherit" size={size} thickness={(strokeWidth * 44) / 50} className="pillars-progress-spinner" aria-label="Loading" />;
}
